<script>
import { mapActions, mapMutations } from "vuex";

import { Page, Footer } from "@styled/global";

export default {
   data() {
      return {
         email: "",
         password: "",
         // email: "customer@purple.com",
         // password: "lazyload",
      };
   },
   methods: {
      ...mapMutations("theme", ["setTheme"]),
      ...mapActions("auth", ["signIn"]),
      submitForm: async function(e) {
         e.preventDefault();
         const email = this.email;
         const password = this.password;
         const user = await this.signIn({ email, password });

         if (user) {
            this.$router.push("/mortgage");
            this.setTheme(user.theme);
         } else {
            alert("USER NOT FOUND");
         }

         return false;
      },
   },
   render() {
      const labelStyle = {
         width: "100px",
         fontSize: "14px",
         lineHeight: "24px",
         textAlign: "right",
         margin: "4px",
      };

      const buttonStyle = {
         width: "100px",
         fontSize: "14px",
         lineHeight: "24px",
         textAlign: "center",
         margin: "4px",
         border: "1px solid #000",
         background: this.$store.state.theme.theme.primaryColor,
         color: this.$store.state.theme.theme.secondaryColor,
      };

      const inputStyle = {
         width: "200px",
         fontSize: "14px",
         lineHeight: "24px",
         textAlign: "left",
         margin: "4px",
         padding: "0 4px",
         border: "1px solid #000",
      };

      return (
         <Page>
            <ShadowHeader />
            <form
               style={{
                  display: "flex",
                  flexDirection: "column",
                  marginTop: "100px",
                  alignItems: "center",
               }}
               onsubmit={this.submitForm}
            >
               <div style={{ display: "flex" }}>
                  <label style={labelStyle}>Email</label>
                  <input
                     required
                     value={this.email}
                     type="email"
                     placeholder="email"
                     onchange={(e) => (this.email = e.target.value)}
                     style={inputStyle}
                  />
               </div>

               <div style={{ display: "flex", margin: "4px" }}>
                  <label style={labelStyle}>Password</label>
                  <input
                     required
                     value={this.password}
                     type="password"
                     placeholder="password"
                     onchange={(e) => (this.password = e.target.value)}
                     style={inputStyle}
                  />
               </div>

               <div style={{ display: "flex", margin: "4px" }}>
                  <label style={labelStyle}></label>
                  <button style={buttonStyle} type="submit">
                     Sign In
                  </button>
               </div>
            </form>
         </Page>
      );
   },
};
</script>
